import React from 'react';
import { Paper, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from 'recharts';
import { contentCardSx } from '../../../../styles/standaloneLayoutTokens';

function formatHour(h) {
  if (h === 0) return '12a';
  if (h < 12) return `${h}a`;
  if (h === 12) return '12p';
  return `${h - 12}p`;
}

export default function PeakHoursChart({ data }) {
  const theme = useTheme();

  if (!data || data.length === 0) return null;

  const hasAny = data.some(d => d.count > 0);
  if (!hasAny) return null;

  return (
    <Paper elevation={0} sx={{ ...contentCardSx, p: 2.5 }}>
      <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 2 }}>
        Peak Hours
      </Typography>

      <ResponsiveContainer width="100%" height={260}>
        <BarChart data={data} margin={{ top: 4, right: 8, left: -16, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke={theme.palette.divider} />
          <XAxis
            dataKey="hour"
            tickFormatter={formatHour}
            tick={{ fontSize: 11 }}
            stroke={theme.palette.text.secondary}
          />
          <YAxis
            allowDecimals={false}
            tick={{ fontSize: 12 }}
            stroke={theme.palette.text.secondary}
          />
          <Tooltip
            labelFormatter={(h) => formatHour(h)}
            formatter={(value) => [value, 'Check-ins']}
            contentStyle={{
              backgroundColor: theme.palette.background.paper,
              border: `1px solid ${theme.palette.divider}`,
              borderRadius: 8,
            }}
          />
          <Bar
            dataKey="count"
            name="Check-ins"
            fill={theme.palette.info.main}
            radius={[4, 4, 0, 0]}
          />
        </BarChart>
      </ResponsiveContainer>
    </Paper>
  );
}
